import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps } from "vue"
import _imports_0 from '@/assets/images/swipe_bar.png'
import _imports_1 from '@/assets/images/close_icon.png'


const _hoisted_1 = { class: "pantry-search-view" }
const _hoisted_2 = { class: "pantry-search-view-search-input-area" }
const _hoisted_3 = { class: "pantry-search-view-search-input-button" }
const _hoisted_4 = { class: "pantry-search-view-main-area" }
const _hoisted_5 = {
  class: "pantry-search-view-swipe-bar",
  ref: "swaipBar"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-search-view-swipe-bar-image",
  src: _imports_0
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-search-view-close-image-icon",
  src: _imports_1
}, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "pantry-search-view-search-keyword-area" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "pantry-search-view-search-keyword-category-text" }, "対象", -1)
const _hoisted_11 = { class: "pantry-search-view-search-keyword-tag-area" }
const _hoisted_12 = { class: "pantry-search-view-search-category-area" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "pantry-search-view-search-category-text" }, "検索結果", -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "pantry-search-view-title-text" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "pantry-search-view-category-text" }, "おすすめ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantrySearchTagItem = _resolveComponent("PantrySearchTagItem")
  const _component_PantrySearchListLineView = _resolveComponent("PantrySearchListLineView")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: "pantry-search-view-search-input-text",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickSearch(...args)))
        }, "テキスト入力で追加する")
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6
      ], 512),
      _createVNode("div", {
        class: "pantry-search-view-close-image",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickClose(...args)))
      }, [
        _hoisted_7
      ]),
      (_ctx.isShowSearch())
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode("div", _hoisted_11, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searchFoodList, (item, index) => {
                  return (_openBlock(), _createBlock(_component_PantrySearchTagItem, {
                    key: index,
                    data: item.food,
                    onDeleteFood: _ctx.deleteFood
                  }, null, 8, ["data", "onDeleteFood"]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode("div", {
                class: "pantry-search-view-search-info-text",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickSearchConditions(...args)))
              }, "検索条件")
            ])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_14, [
            _createVNode("div", _mergeProps({ class: "pantry-search-view-header-area" }, _ctx.isShowList), [
              _withDirectives(_createVNode("div", _hoisted_15, "食材をタップして選択", 512), [
                [_vShow, _ctx.isShowFoodTapMessage()]
              ])
            ], 16),
            _hoisted_16
          ])),
      _createVNode("div", {
        class: "pantry-search-view-list-area",
        onScrollPassive: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onScroll($event)))
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getList(), (item) => {
          return (_openBlock(), _createBlock(_component_PantrySearchListLineView, {
            key: item.id,
            list: item.list,
            onSelectRecipe: _ctx.onSelectRecipe
          }, null, 8, ["list", "onSelectRecipe"]))
        }), 128 /* KEYED_FRAGMENT */))
      ], 32)
    ])
  ]))
}